import {Component, OnInit, ViewChild} from "@angular/core";
import {AuthService, LoginType, provideEntityModel, ValidationMessage} from "@fedelta-pos/data-client";
import {NavigationService} from "../../orchestration/navigation.service";
import {LoadingService} from "../../ui-elements/loading/loading.service";
import {Page} from "../../orchestration/page";
import {MessageDetails, MessageLevel} from "../../notification/message/message";
import {NotificationService} from "../../notification/notification.service";
import {IdentityModel} from "../identity.model";
import {FormComponent} from "../../inputs/form/form.component";
import {DateTime} from "../../string-utils/date-time";
import {IdentityEntityModel} from "../identity-entity.model";
import {CustomerDetails, CustomerDetailsService} from "../../customer-info/customer-details.service";
import {OrderingContextModel} from "../../ordering-context/ordering-context.model";

@Component({
    selector: "woa-profile-edit-page",
    templateUrl: "profile-edit-page.component.html",
    providers: [
        provideEntityModel(IdentityEntityModel),
        {provide: Page, useExisting: ProfileEditPageComponent}
    ]
})

export class ProfileEditPageComponent extends Page implements OnInit {
    @ViewChild(FormComponent) public form: FormComponent;

    LoginType = LoginType;

    editingMember: boolean = false;
    editingCustomer: boolean = false;
    customerDetails: CustomerDetails;

    constructor(private notificationService: NotificationService,
                private loadingService: LoadingService,
                public identityEntityModel: IdentityEntityModel,
                public identityModel: IdentityModel,
                private orderingContextModel: OrderingContextModel,
                public authService: AuthService,
                public navigationService: NavigationService,
                private customerDetailsService: CustomerDetailsService) {
        super();
        this.customerDetails = this.customerDetailsService.loadCustomer();
    }

    async ngOnInit(): Promise<void> {
        await this.identityEntityModel.loadEntity(this.authService.getLoggedInIdentityId());
        if (this.identityEntityModel.data.dob) {
            this.identityEntityModel.data.dob = DateTime.formatDateForEdit(new Date(this.identityEntityModel.data.dob.substring(0, 10)));
        }
    }

    get memberEmail(): string {
        return this.identityEntityModel.data.email;
    }

    set memberEmail(email: string) {
        this.identityEntityModel.data.email = email ? email.toLowerCase() : email;
    }

    get customerEmail(): string {
        return this.customerDetails.email;
    }

    set customerEmail(email: string) {
        this.customerDetails.email = email ? email.toLowerCase() : email;
    }

    get canEditMember(): boolean {
        return this.identityModel.currentMember && this.identityModel.currentMember.allowProfileEdit;
    }

    forgetCustomer(): void {
        this.customerDetailsService.removeCustomer();
        this.orderingContextModel.applyIdentityContactDetails(this.identityModel.currentIdentity, this.orderingContextModel.applySavedCustomerDetails(true));
        // noinspection JSIgnoredPromiseFromCall
        this.navigationService.dismissPage(this);
    }

    saveProfile(): void {
        if (!this.form.valid) {
            return;
        }

        if (this.editingMember) {
            // noinspection JSIgnoredPromiseFromCall
            this.loadingService.performWithSpinner(async () => {
                try {
                    const validationMessages: ValidationMessage[] = await this.identityEntityModel.saveEntity();
                    if (validationMessages) {
                        this.form.applyServerValidationMessages(validationMessages);
                    } else {
                        this.identityModel.applyIdentity(this.identityEntityModel.data);
                        // noinspection ES6MissingAwait
                        this.navigationService.dismissPage(this);
                    }
                } catch (error) {
                    if (error.displayable) {
                        this.notificationService.displayFooterMessage(new MessageDetails(MessageLevel.ERROR, error.data.messageKey, error.data.messageParams));
                    } else {
                        this.notificationService.displayFooterMessage(new MessageDetails(MessageLevel.ERROR, "woa.notification.profileChangeFailed"));
                    }
                }
            });
        } else {
            this.customerDetailsService.saveCustomer(this.customerDetails);
            this.orderingContextModel.applyIdentityContactDetails(this.identityModel.currentIdentity, this.orderingContextModel.applySavedCustomerDetails(true));
            // noinspection JSIgnoredPromiseFromCall
            this.navigationService.dismissPage(this);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/identity/profile-edit-page/profile-edit-page.component.ts